import { Product } from '@features/catalog/models/product.models';

/** Ids de categorías asignadas al producto (orden de asignación cuando viene `categories`). */
export function assignedCategoryIdsFromProduct(product: Product): string[] {
  const fromList = (product.categories ?? []).map((category) => category.id.trim()).filter(Boolean);
  if (fromList.length) {
    return dedupeCategoryIds(fromList);
  }
  const primary = product.primaryCategory?.id?.trim();
  return primary ? [primary] : [];
}

export function dedupeCategoryIds(ids: readonly string[]): string[] {
  return [...new Set(ids.map((id) => String(id).trim()).filter(Boolean))];
}

/** Nombres de categorías asignadas (orden del API cuando viene `categories`). */
export function productCategoryNamesFromProduct(product: Product): string[] {
  return (product.categories ?? []).map((category) => category.name.trim()).filter(Boolean);
}

/** Texto para listados: nombres unidos, fallback por opciones o etiqueta sin categoría. */
export function formatProductCategoriesDisplay(
  product: Product,
  categoryOptions: ReadonlyArray<{ value: string; label: string }> = [],
  uncategorizedLabel = '—'
): string {
  const names = productCategoryNamesFromProduct(product);
  if (names.length) {
    return names.join(', ');
  }

  const ids = assignedCategoryIdsFromProduct(product);
  if (!ids.length) {
    return uncategorizedLabel;
  }

  const labelById = new Map(categoryOptions.map((opt) => [opt.value, opt.label]));
  const labels = ids.map((id) => labelById.get(id)?.trim()).filter((label): label is string => !!label);
  return labels.length ? labels.join(', ') : uncategorizedLabel;
}
